
    import { defineComponent, PropType } from 'vue'
    import { Chip } from '@progress/kendo-vue-buttons'

    type TypeRounded = "small" | "medium" | "large" | "full" | null

    export default defineComponent({
        name: 'MyIndicator',

        components: {
            Chip
        },

        /********************************************************************************************************************
         PUBLIC PROPERTIES
         ********************************************************************************************************************/
        props: {
            text: { type: String as PropType<string>, required: true },
            rounded: { type: String as PropType<TypeRounded>, required: false, default: () => "full" },
            clickable: { type: Boolean as PropType<boolean>, required: false, default: () => false }
        }
    });
